<template>
  <div class="parsed-details d-flex flex-column i-p-6 i-mb-11">
    <div
      v-if="customer.parsedDetails.length > 0"
      class="title i-text-button-2 i-text-neutral-120 i-mb-6"
    >
      Customer Details
    </div>
    <template
      v-for="(parsedDetail, index) in customer.parsedDetails"
      :key="`name-${index}`"
    >
      <parsed-detail-item
        v-if="parsedDetail?.instances?.[0]"
        class="d-flex align-items-start"
        :hide-label="true"
        :parsed-details-type="parsedDetail?.type"
        :parsed-detail="parsedDetail?.instances?.[0]"
        :right-icon="rightIcon"
        @onRightIconClick="onClickBlocklistItem"
      />
    </template>
  </div>
</template>

<script>
import * as parsedDetailsTypes from '../../constants/parsedDetailsTypes';
import ParsedDetailItem from '../documents/ParsedDetailItem';
import parsedDetailsConfig from '../../constants/parsedDetailsConfig';
import { mapMutations } from 'vuex';

export default {
  components: { 'parsed-detail-item': ParsedDetailItem },
  props: {
    customer: {
      type: Object,
      required: true,
    },
    showBlocklistSuggestions: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      parsedDetailsTypes,
      keys: [
        parsedDetailsTypes.NAME,
        parsedDetailsTypes.COMPANY,
        parsedDetailsTypes.ADDRESS,
      ],
    };
  },
  computed: {
    rightIcon() {
      return this.showBlocklistSuggestions ? 'small-user-block' : null;
    },
  },
  methods: {
    ...mapMutations(['setShowBlocklistSuggestions']),
    getParsedDetailsByType(detailType) {
      const { show = () => true } = parsedDetailsConfig[detailType];
      return this.parsedDetails.filter(
        ({ instances, type }) => type === detailType && instances.some(show),
      );
    },
    onClickBlocklistItem() {
      if (!this.showBlocklistSuggestions) {
        this.setShowBlocklistSuggestions(true);
      }
    },
  },
};
</script>

<style lang="scss">
.parsed-details {
  .parsed-detail-item {
    width: 100%;
  }
}
</style>
